// extracted by mini-css-extract-plugin
module.exports = {"pathwaysStart":"styles_pathwaysStart__215l4","text":"styles_text__2ZniQ","profileSetupTitle":"styles_profileSetupTitle__1KzUb","slideInFromRight":"styles_slideInFromRight__13-23"};